import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class AsnafCategoryModel extends BaseModel {
  RouteName = "AsnafCategory";
  protected AuthState: boolean = true;
}
